import React, { useState } from 'react';
import SEO from '../components/SEO';
import seoData from '../config/seoData';
import { Phone, MessageCircle, Mail, MapPin, Clock, CheckCircle, Wrench, Instagram, ArrowRight, ChevronDown, Shield, Award, FileCheck, Gauge, Zap, Package, Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { useNavigate, Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import { useToast } from '../hooks/use-toast';

const ReformaTennantA5 = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    telefone: '',
    email: '',
    cidade: '',
    mensagem: ''
  });

  const whatsappNumber = "5531971823249";

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Olá! Gostaria de solicitar um orçamento para Reforma Tennant A5.");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const handleFormSubmit = (type) => {
    // Validação
    if (!formData.nome || !formData.telefone) {
      toast({
        title: "Campos obrigatórios",
        description: "Por favor, preencha Nome e Telefone.",
        variant: "destructive"
      });
      return;
    }

    const message = `
*SOLICITAÇÃO REFORMA TENNANT A5*

*Nome:* ${formData.nome}
${formData.empresa ? `*Empresa:* ${formData.empresa}` : ''}
*Telefone:* ${formData.telefone}
${formData.email ? `*E-mail:* ${formData.email}` : ''}
${formData.cidade ? `*Cidade/UF:* ${formData.cidade}` : ''}
${formData.mensagem ? `*Mensagem:* ${formData.mensagem}` : ''}
    `.trim();

    if (type === 'whatsapp') {
      window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } else {
      const emailBody = encodeURIComponent(message.replace(/\*/g, ''));
      window.location.href = `mailto:Wellington@wellttec.com?subject=Solicitação Reforma Tennant A5&body=${emailBody}`;
    }
  };

  const problemas = [
    "Perda de tração",
    "Escovas desgastadas",
    "Rodo com vazamentos",
    "Sistema elétrico com falhas",
    "Baixa autonomia da bateria",
    "Tanques com vazamentos",
    "Desgaste estrutural",
    "Máquina parada frequentemente"
  ];

  const etapas = [
    "Diagnóstico técnico completo",
    "Desmontagem e inspeção",
    "Recuperação estrutural",
    "Revisão do sistema de tração",
    "Revisão elétrica e bateria",
    "Troca de escovas e disco",
    "Substituição de rodo",
    "Revisão de tanques",
    "Pintura técnica industrial",
    "Testes operacionais completos"
  ];

  const diferenciais = [
    { metric: "A5", title: "Especialista em Tennant A5", desc: "Reforma completa de lavadoras pedestres tracionadas Tennant A5" },
    { metric: "+7", title: "Anos de experiência", desc: "7 anos atuando com reforma e manutenção de lavadoras industriais" },
    { metric: "100%", title: "Peças originais e compatíveis", desc: "Garantia de qualidade em todos os componentes" },
    { metric: "BR", title: "Atendimento em todo Brasil", desc: "Não importa onde você está, atendemos" },
    { metric: "PRO", title: "Equipe técnica experiente", desc: "Profissionais qualificados e certificados" },
    { metric: "DOC", title: "Reformas documentadas", desc: "Registro completo de todas as etapas" },
    { metric: "QA", title: "Testes operacionais", desc: "Validação completa antes da entrega" },
    { metric: "80cm", title: "Faixa de limpeza", desc: "Alto rendimento com 80cm de largura" }
  ];

  return (
    <div className="min-h-screen
      <SEO 
        title={seoData['/reforma-tennant-a5'].title}
        description={seoData['/reforma-tennant-a5'].description}
        canonical={seoData['/reforma-tennant-a5'].canonical}
      /> bg-gradient-to-b from-green-50 to-white">
      {/* Fixed WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50 animate-bounce-slow">
        <Button
          onClick={handleWhatsAppClick}
          className="bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
        >
          <MessageCircle className="w-8 h-8" />
        </Button>
      </div>

      {/* Header */}
      <header className="bg-green-800 text-white py-4 px-6 sticky top-0 z-40 shadow-xl">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png" 
              alt="WellTec Logo" 
              className="h-16 w-auto"
            />
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-green-400 transition-colors">Início</Link>
            <Link to="/servicos" className="hover:text-green-400 transition-colors">Serviços</Link>
            <Link to="/equipamentos-disponiveis" className="hover:text-green-400 transition-colors">Catálogo</Link>
            <Link to="/limpeza-pos-obra" className="hover:text-green-400 transition-colors">Limpeza Pós-Obra</Link>
            <Link to="/locacao-lavadora-piso" className="hover:text-green-400 transition-colors">Locação</Link>
            <Link to="/blog" className="hover:text-green-400 transition-colors">Blog</Link>
            <a 
              href="https://www.instagram.com/welltecbrasil/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-green-400 transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <Button onClick={handleWhatsAppClick} className="bg-green-500 hover:bg-green-600 border-2 border-green-400">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-green-800 border-t border-green-700 shadow-xl">
            <div className="flex flex-col space-y-1 p-4">
              <button
                onClick={() => { navigate('/'); setMobileMenuOpen(false); }}
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors">
                Início
              </button>
              <button
                onClick={() => { navigate('/servicos'); setMobileMenuOpen(false); }}
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors">
                Serviços
              </button>
              <button
                onClick={() => { navigate('/equipamentos-disponiveis'); setMobileMenuOpen(false); }}
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors">
                Catálogo
              </button>
              <button
                onClick={() => { navigate('/locacao-lavadora-piso'); setMobileMenuOpen(false); }}
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors">
                Locação
              </button>
              <button
                onClick={() => { navigate('/blog'); setMobileMenuOpen(false); }}
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors">
                Blog
              </button>
              <a
                href="https://www.instagram.com/welltecbrasil/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-left py-3 px-4 hover:bg-green-700 rounded transition-colors flex items-center">
                <Instagram className="w-5 h-5 mr-2" />
                Instagram
              </a>
              <Button 
                onClick={() => { handleWhatsAppClick(); setMobileMenuOpen(false); }}
                className="bg-green-500 hover:bg-green-600 w-full mt-2">
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </Button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section 
        className="relative bg-gradient-to-br from-green-900 via-green-800 to-green-900 text-white py-24 md:py-32 overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(22, 101, 52, 0.9), rgba(21, 128, 61, 0.85)), url('https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=1600')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/50 to-transparent"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-6 animate-pulse">
              ⭐ REFORMA PREMIUM TENNANT A5
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Reforma Completa de Lavadora Tennant A5
            </h1>
            
            <p className="text-lg md:text-xl mb-8 text-green-50 leading-relaxed">
              Especialistas em <strong>reforma e revitalização</strong> de lavadoras pedestres tracionadas <strong>Tennant A5</strong>. 
              Devolvemos sua máquina com <strong>desempenho de fábrica</strong>, alto rendimento e garantia total.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button
                onClick={handleWhatsAppClick}
                size="lg"
                className="bg-green-500 hover:bg-green-600 text-white text-lg px-8 py-6 shadow-2xl hover:scale-105 transition-all duration-300"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Solicitar Orçamento Agora
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-green-900 text-lg px-8 py-6"
                onClick={() => window.location.href = 'tel:+5531971823249'}
              >
                <Phone className="w-5 h-5 mr-2" />
                (31) 97182-3249
              </Button>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="text-2xl font-bold text-green-400">80cm</div>
                <div className="text-sm text-green-100">Faixa de Limpeza</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="text-2xl font-bold text-green-400">80L</div>
                <div className="text-sm text-green-100">Tanque</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="text-2xl font-bold text-green-400">Tração</div>
                <div className="text-sm text-green-100">Alto Rendimento</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="text-2xl font-bold text-green-400">+7</div>
                <div className="text-sm text-green-100">Anos Experiência</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Problemas Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Sua Tennant A5 apresenta algum desses problemas?
              </h2>
              <p className="text-lg text-gray-600">
                Nossa reforma resolve todos esses problemas e devolve sua máquina como nova
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {problemas.map((problema) => (
                <Card key={problema} className="border-red-200 hover:border-red-400 transition-all duration-300 hover:shadow-lg">
                  <CardContent className="p-4 flex items-start gap-3">
                    <div className="text-red-500 mt-1">
                      <ChevronDown className="w-5 h-5" />
                    </div>
                    <p className="text-sm text-gray-700 font-medium">{problema}</p>
                  </CardContent>
                </Card>
              ))}
            </div>

            <div className="text-center mt-12">
              <Button
                onClick={handleWhatsAppClick}
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white px-12 py-6 text-lg"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Solicitar Diagnóstico Técnico
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Etapas da Reforma */}
      <section className="py-20 bg-green-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Processo de Reforma Tennant A5
              </h2>
              <p className="text-lg text-gray-600">
                10 etapas para devolver sua A5 com desempenho de fábrica
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {etapas.map((etapa, index) => (
                <Card key={etapa} className="border-green-200 hover:border-green-500 transition-all duration-300 hover:shadow-lg">
                  <CardContent className="p-6 flex items-start gap-4">
                    <div className="bg-green-600 text-white rounded-full w-12 h-12 flex items-center justify-center font-bold text-lg flex-shrink-0">
                      {index + 1}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-900 text-lg mb-1">{etapa}</h3>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Galeria: Antes da Reforma */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Galeria: Antes da Reforma
              </h2>
              <p className="text-lg text-gray-600">
                Veja o estado real de uma Tennant A5 antes do processo de reforma completa
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/v56iffwp_Lavadora%20de%20piso%20A5.jfif" 
                  alt="Tennant A5 antes da reforma - visão geral" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Máquina completa - Estado inicial</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/bo9x0yp5_Lavadora%20de%20piso%20A5-baterias%20%281%29.jfif" 
                  alt="Sistema de baterias antes da reforma" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Sistema elétrico e baterias</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/0864ztlv_Lavadora%20de%20piso%20A5%20rodo.jfif" 
                  alt="Painel de controle desgastado" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Painel de controle e comandos</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/q5ltmpyz_Lavadora%20de%20piso%20A5%20escovas.jfif" 
                  alt="Disco e escovas desgastadas" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Disco de limpeza desgastado</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/8dh40ufx_Lavadora%20de%20piso%20A5%20rodas.jfif" 
                  alt="Sistema de tração e mecânica" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Sistema de tração e rodas</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/sf9rntvl_Lavadora%20de%20piso%20A5%20motor.jfif" 
                  alt="Componentes mecânicos internos" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4">
                  <p className="text-sm font-semibold text-gray-700">Componentes mecânicos internos</p>
                </CardContent>
              </Card>
            </div>

            <div className="text-center mt-12">
              <p className="text-gray-600 mb-6">
                Sua Tennant A5 está com problemas similares? Solicite um diagnóstico técnico completo!
              </p>
              <Button
                onClick={handleWhatsAppClick}
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white px-12 py-6 text-lg"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Solicitar Orçamento de Reforma
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Galeria: Depois da Reforma */}
      <section className="py-20 bg-gradient-to-br from-green-50 to-green-100">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                ✨ RESULTADO FINAL
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Galeria: Depois da Reforma
              </h2>
              <p className="text-lg text-gray-600">
                Veja a transformação completa! Sua Tennant A5 com desempenho de fábrica
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/2q4xunhg_eae4d7da-2a4c-4c97-b604-1217be618150.jfif" 
                  alt="Disco de limpeza após reforma" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Pad de limpeza instalado</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/xs2x1c8j_60d67340-f2f1-4057-804a-506224c964c7.jfif" 
                  alt="Motor e componentes mecânicos revisados" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Motor revisado e testado</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/poaq4k4y_58f61dd1-5fd9-47f1-b039-4f0b2036e353.jfif" 
                  alt="Disco de limpeza novo" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Disco novo de 80cm</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/ykt1st4k_9a4831e4-88aa-4012-9924-20754aa6a2a2.jfif" 
                  alt="Rodo após reforma" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Rodo novo instalado</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/kgk7uz5g_c4c31ada-cabf-4c67-a932-49dcab357bd8.jfif" 
                  alt="Tennant A5 completa após reforma" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Máquina completa renovada</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/p1v7cyo2_a80d7d61-1203-4185-b9e5-7ade1961881f.jfif" 
                  alt="Sistema de baterias restaurado" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Baterias e elétrica OK</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/4g8xzezv_6cd27ae1-d015-45ac-9910-303883fa19f0.jfif" 
                  alt="Parte interna revisada" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Mecânica interna revisada</p>
                </CardContent>
              </Card>

              <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-green-200">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9x55xfv6_0dae03fb-7ddb-4235-ac91-d0c761ad3685.jfif" 
                  alt="Deck de escovas renovado" 
                  className="w-full h-64 object-cover"
                />
                <CardContent className="p-4 bg-green-50">
                  <p className="text-sm font-semibold text-green-800">✅ Deck de escovas novo</p>
                </CardContent>
              </Card>
            </div>

            <div className="text-center mt-12">
              <div className="bg-white rounded-lg shadow-xl p-8 max-w-3xl mx-auto border-2 border-green-300">
                <h3 className="text-2xl font-bold text-green-900 mb-4">
                  🎯 Transformação Completa Garantida!
                </h3>
                <p className="text-gray-700 mb-6">
                  Sua Tennant A5 passa por todas as etapas de reforma e volta com <strong>desempenho de fábrica</strong>, 
                  garantia total e pronta para trabalhar em supermercados, fábricas e galpões.
                </p>
                <Button
                  onClick={handleWhatsAppClick}
                  size="lg"
                  className="bg-green-600 hover:bg-green-700 text-white px-12 py-6 text-lg shadow-lg hover:scale-105 transition-all"
                >
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Solicitar Orçamento de Reforma Agora
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Por que escolher a WellTec?
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {diferenciais.map((item) => (
                <Card key={item.title} className="border-green-200 hover:border-green-500 transition-all duration-300 hover:shadow-xl">
                  <CardContent className="p-6 text-center">
                    <div className="bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                      {item.metric}
                    </div>
                    <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Ambientes Ideais */}
      <section className="py-20 bg-gradient-to-br from-green-900 to-green-800 text-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Tennant A5: Ideal para Diversos Ambientes
            </h2>
            <p className="text-lg mb-8 text-green-100">
              Lavadora pedestre tracionada com <strong>80cm de faixa de limpeza</strong> e <strong>tanque de 80 litros</strong>, 
              perfeita para supermercados, fábricas e galpões que exigem <strong>alto rendimento e produtividade</strong>.
            </p>
            
            <div className="grid md:grid-cols-3 gap-6 mt-10">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20">
                <Package className="w-12 h-12 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-2">Supermercados</h3>
                <p className="text-sm text-green-100">Limpeza eficiente de corredores e áreas de vendas</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20">
                <Gauge className="w-12 h-12 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-2">Fábricas</h3>
                <p className="text-sm text-green-100">Alto rendimento para ambientes industriais</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20">
                <Zap className="w-12 h-12 mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-2">Galpões</h3>
                <p className="text-sm text-green-100">Produtividade para grandes áreas</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Formulário de Contato */}
      <ContactForm />

      {/* Footer */}
      <footer className="bg-green-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png" 
                  alt="WellTec Logo" 
                  className="h-20 w-auto"
                />
              </div>
              <p className="text-green-200 mb-4">
                Especialistas em reforma e manutenção de lavadoras e varredeiras industriais.
              </p>
              <a 
                href="https://www.instagram.com/welltecbrasil/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-green-300 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>@welltecbrasil</span>
              </a>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Links Rápidos</h5>
              <ul className="space-y-2">
                <li><Link to="/" className="text-green-200 hover:text-white transition-colors">Início</Link></li>
                <li><Link to="/servicos" className="text-green-200 hover:text-white transition-colors">Serviços</Link></li>
                <li><Link to="/locacao-lavadora-piso" className="text-green-200 hover:text-white transition-colors">Locação</Link></li>
                <li><Link to="/blog" className="text-green-200 hover:text-white transition-colors">Blog</Link></li>
                <li></li>
                <li></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Contato</h5>
              <ul className="space-y-2 text-green-200">
                <li className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  (31) 97182-3249
                </li>
                <li className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  Mário Campos, MG
                </li>
                <li className="flex items-center gap-2">
                  <Clock className="w-4 h-4" />
                  Seg-Sex: 08:00-18:00
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-green-800 pt-8 text-center text-green-300">
            <p>&copy; 2025 WellTec - Reforma Tennant A5. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ReformaTennantA5;
